import { useEffect, useMemo, useRef, useState } from 'react';

import { Empty2 } from '@/components/icon';
import { AiImageModelType, AiImageReq, ResourceHistory, UrlInfo } from '@/interface/aigc';

import styles from './index.module.less';
import ImageHistoryItem from './item';

export interface IAigcImageHistoryProps {
  histories: ResourceHistory[];
  isHorizontal: boolean;
  pagination: {
    page: number;
    size: number;
    total: number;
  };
  loading: boolean;
  model?: AiImageModelType;
  generateImages: (postData: AiImageReq) => void;
  getSrc: (src: UrlInfo) => void;
  onDelete: (id: string) => void;
}

const AigcImageHistory: React.FC<IAigcImageHistoryProps> = (props) => {
  const { histories = [], isHorizontal, pagination, loading, generateImages, getSrc, onDelete } = props;
  const [selectedImage, setSelectedImage] = useState<string>('initUrl');
  const latestItemRef = useRef<HTMLDivElement>(null);
  const historyLen = useRef<number>(histories.length);

  useEffect(() => {
    if (historyLen.current > 1 && histories.length > historyLen.current) {
      latestItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    historyLen.current = histories.length;
  }, [histories.length]);

  useEffect(() => {
    latestItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [pagination.page]);

  const handleSelect = (url: UrlInfo) => {
    if (!url.url) return;
    if (url.url === selectedImage) {
      setSelectedImage('');
      getSrc({ url: '', name: '' });
      return;
    }
    setSelectedImage(url.url);
    getSrc(url);
  };

  const contentDom = useMemo(() => {
    if (loading) return null;
    return histories.length === 0
      ? (
        <div className={styles.placeholder}>
          <Empty2 />
          <div>暂未生成素材</div>
        </div>
      ) : (
        <div className={styles.history}>
          {histories.map((e, index) => (
            <div key={e.relateId || index} ref={index === 0 ? latestItemRef : null}>
              <ImageHistoryItem
                key={e.relateId || index}
                history={e}
                selectedImage={selectedImage}
                isHorizontal={isHorizontal}
                generateImages={generateImages}
                handleSelect={handleSelect}
                onDelete={onDelete}
              />
            </div>
          ))}
        </div>
      );
  }, [loading, histories, selectedImage, isHorizontal, generateImages, getSrc, onDelete]);

  return (
    <div className={styles.container}>
      {contentDom}
    </div>
  );
};

export default AigcImageHistory;
